import { rfqQuoteDetailsSalesRepProductListStyles as styles } from "@hardware/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList";
import { colorStrings, mediaQueriesBP } from "@hardware/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.quoteLineInfoCustomGridItem = {
    css: css`
        flex-direction: column;
    `,
    width: 10,
};

styles.quoteLineInfoContainer = {
    gap: 20,
    css: css`
        padding-top: 10px;
    `,
};

styles.quoteLineInfoCustomContainer = {
    gap: 0,
    css: css`
        padding-top: 10px;

        .file-link {
            height: auto;
            color: ${getColor(colorStrings.primaryMain)};
            min-width: 180px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            gap: 10px;
            font-size: 14px;
            font-weight: 700;

            ${mediaQueriesBP.maxLG} {
                height: auto;
            }
        }
    `,
};

styles.orderLineNotesGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

styles.toggleNotesLink = {
    css: css`
        margin-bottom: 10px;
    `,
};

styles.notesTextArea = {
    css: css`
        min-width: 100%;
        max-width: 100%;
        min-height: 50px;
    `,
};

styles.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
    `,
};

styles.addQuoteLineItemButton = {
    variant: "secondary",
    css: css`
        width: auto;
        margin-inline-end: 15px;
        ${mediaQueriesBP.maxLG} {
            width: 100%;
            margin-inline-end: 0;
        }
    `,
};

styles.quoteAllButton = {
    css: css`
        ${mediaQueriesBP.maxLG} {
            width: 100%;
        }
    `,
};

styles.headerContainer = {
    gap: 20,
    offsetCss: css`
        ${mediaQueriesBP.maxLG} {
            flex-direction: column;
            align-items: flex-start;
        }
    `,
};

styles.quoteAllGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        justify-content: flex-end;
        ${mediaQueriesBP.maxLG} {
            gap: 10px;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
        }
    `,
};
